import { ServiceLevelsKpisActionTypes } from './constants';

type ServiceLevelsKpisAction = { type: string, payload: {} | string };

export const serviceLevelsKpisApiResponseSuccess = (actionType: string, data: any): ServiceLevelsKpisAction => ({
    type: ServiceLevelsKpisActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const serviceLevelsKpisApiResponseError = (actionType: string, error: string): ServiceLevelsKpisAction => ({
    type: ServiceLevelsKpisActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const serviceLevelsKpisGetServiceLevels = (query: string): ServiceLevelsKpisAction => ({
    type: ServiceLevelsKpisActionTypes.GET_SHIPMENTS_SERVICE_LEVELS_REQUEST,
    payload: { query },
});

export const serviceLevelsKpisGetDayServiceLevels = (query: string): ServiceLevelsKpisAction => ({
    type: ServiceLevelsKpisActionTypes.GET_SHIPMENTS_DAY_SERVICE_LEVELS_REQUEST,
    payload: { query },
});

export const serviceLevelsKpisGetServiceLevelsByTimeframe = (query: string): ServiceLevelsKpisAction => ({
    type: ServiceLevelsKpisActionTypes.GET_SHIPMENTS_SERVICE_LEVELS_BY_TIMEFRAME_REQUEST,
    payload: { query },
});

export const serviceLevelsKpisGetAggregatedCost = (query: string): ServiceLevelsKpisAction => ({
    type: ServiceLevelsKpisActionTypes.GET_SHIPMENTS_AGGREGATED_COST_REQUEST,
    payload: { query },
});